module.exports = __webpack_public_path__ + "static/media/icon_delete_patient.351197a4.svg";